var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookClosedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1710_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0833 6.33301V31.6663H11.0833C10.2434 31.6663 9.43799 31.3327 8.84412 30.7388C8.25026 30.145 7.91663 29.3395 7.91663 28.4997V9.49967C7.91663 8.65982 8.25026 7.85437 8.84412 7.2605C9.43799 6.66664 10.2434 6.33301 11.0833 6.33301H30.0833Z",
    stroke: "#FAE0C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0833 25.333H11.0833C10.2434 25.333 9.43799 25.6666 8.84412 26.2605C8.25026 26.8544 7.91663 27.6598 7.91663 28.4997",
    stroke: "#FAE0C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.667H23.75",
    stroke: "#FAE0C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1710_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookClosedIcon);
export default __webpack_public_path__ + "static/media/bookClosedIcon.9a109eed0a3ef62464aa64c15711a463.svg";
export { ForwardRef as ReactComponent };